<template>
  <BaseCard gray>
    <div
      :class="[
        $style.featureContainer,
        {
          [$style.limitHeight]: limitHeight
        }
      ]"
    >
      <div :class="$style.featureHeader">
        <BaseIcon
          :name="iconName"
          size="l"
        />
        <BaseText bold>{{ title }}</BaseText>
      </div>
      <PlanFeature
        v-for="(feature, index) in featureList"
        :key="index"
      >
        {{ $t(`subscription.stripe.features.${feature}`) }}
      </PlanFeature>
    </div>
  </BaseCard>
</template>

<script
  lang="ts"
  setup
>
import type { IconName } from '@/components/base-icon/types';
import PlanFeature from './PlanFeature.vue';

defineProps<{
  title: string;
  iconName: IconName;
  featureList: string[];
  limitHeight?: boolean;
}>();
</script>

<style
  lang="scss"
  module
>
.featureContainer {
  overflow: hidden;
  max-height: 500px;
  transition: max-height 0.3s ease-out;
}

.limitHeight {
  max-height: 165px;
}

.featureHeader {
  display: flex;
  align-items: center;
  gap: $spacing * 0.5;
  margin-bottom: $spacing;
}
</style>
